import { useState, useEffect } from "react";
import validation from "./validation";
import { CreateEntry, UpdateEntry } from '../../providers/dataProvider';
import { CheckNull, convertLocalToUTCDate } from '../../utils/Validate';
import { useLocation, useNavigate } from "react-router-dom";
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";
import { ValidateMessages } from '../../constants/ValidateConstants';
import { validationContact } from "../../validation/ValidateContact";
import urls from "../../constants";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import ValidationField from "./validation";

const useForm = (designationdata) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const [loading, setLoading] = useState(false);

  const [country, setCountry] = useState(null);
  const [salesEngineerData, setSalesEngineerData] = useState(null);
  const [customerStatusData, setCustomerStatusData] = useState(null);
  const [distributortype, setDistributortype] = useState(null);
  const [condepartment, setConDepartment] = useState(null);
  const [condesignation, setConDesignation] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [createMsg, setCreateMsg] = useState(null)
  const [show, setShow] = useState(false);
  const [contactShow, setContactShow] = useState(false);
  const [contact, setContact] = useState([])
  const [contactError, setContactError] = useState({})
  const [contactSubmit, setContactSubmit] = useState(false);
  const [selectedOptions, setSelectedOption] = useState(null);

  const [contacttemp, setContactTemp] = useState({
    id: 0,
    name: "",
    email: "",
    phone: "",
    designationId: 0,
    departmentId: 0,
    designation: ""
  })
  const [docError, setDocError] = useState([]);
  const [editCustomer, seteditCustomer] = useState(null);
  const [formValues, setFormValues] = useState({
    customerName: "",
    address: "",
    fax: '',
    phone: "",
    email: "",
    website: "",
    countryId: 0,
    type: "",
    distributorId: 0,
    assignedEngineerId: 0,
    additionalInfo: "",
    statusId: 1,
    customerContact: [],
    customerDocument: [],
    docs: [],
  });


  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      if (item?.id) {
        if (item?.canEdit !== true) navigate("/dashboard")
        seteditCustomer(item?.row);
      }
      else {
        if (item?.canAdd !== true) navigate("/dashboard")
      }
    }
    else {
      navigate("/dashboard")
    }
  }, [])

  useEffect(() => {
    if (editCustomer) {
      setFormValues((prevValues) => ({
        ...prevValues,
        id: editCustomer?.id,
        customerName: editCustomer?.customerName,
        address: editCustomer?.address,
        phone: editCustomer?.phone,
        fax: editCustomer?.fax,
        email: editCustomer?.email,
        type: editCustomer?.type,
        website: editCustomer?.website,
        countryId: editCustomer?.countryId,
        createdBy: editCustomer?.createdBy,
        distributorId: editCustomer?.distributorId,
        assignedEngineerId: editCustomer?.assignedEngineerId,
        additionalInfo: editCustomer?.additionalInfo,
        designationId: editCustomer?.designationId,
        statusId: editCustomer?.statusId,
        customerContact: editCustomer?.customerContact ? editCustomer?.customerContact : [],
        customerDocument: editCustomer?.customerDocument ? editCustomer?.customerDocument : []      
      }));

        setContact(editCustomer?.customerContact?.map((element, index) => {
        var designationValue = designationdata.filter(function (item) {
          return item.id === element?.designationId;
        });
        if (designationValue)
          element.designation = designationValue[0]?.designationName
        return element;
      }
      ));
    }
  }, [editCustomer, designationdata])

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    setFormValues({
      ...formValues,
      [name]: value,
    });

    const errors = validation({
      ...formValues,
      [name]: value
    });

    setFormErrors({
      ...formErrors,
      [name]: errors[name]
    });
  };

  const handleImageFileChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.files[0].name,
    });

  }

  const handleCountryChange = (selectedOption) => {
    setCountry(selectedOption);
    setFormValues({
      ...formValues,
      countryId: selectedOption?.value,
      phone:""
    });

    const errors = ValidationField({
      ...formValues,
      countryId: selectedOption?.value,
    });

    const countryIdError = errors.countryId;

    setFormErrors({
      ...formErrors,
      countryId: countryIdError,
    });
  };

  const handleStatusChange = (selectedOption) => {
    setCustomerStatusData(selectedOption)
    setFormValues({
      ...formValues,
      statusId: selectedOption?.value,
    });
    setFormErrors({
      ...formErrors,
      statusId: !selectedOption
    });
  };

  const handleCustomerType = (selectedOption) => {
    setSelectedOption(selectedOption);
    const transformedSelectedOptions = selectedOption.map(function (item) {
      return {
        label: item.label,
        value: item.value
      }
    });
    setFormValues({
      ...formValues,
      type: transformedSelectedOptions.map(option => option.value).join(","),
    });

    setFormErrors({
      ...formErrors,
      type: transformedSelectedOptions.length === 0 ? ValidateMessages?.SELECTED_ATLEAST_ONE : ""
    });

  }

  const handleSalesEngChange = (selectedOption) => {
    setFormValues({
      ...formValues,
      assignedEngineerId: selectedOption.value,
    });
    setFormErrors({
      ...formErrors,
      assignedEngineerId: !selectedOption
    });
  };

  const handleDistributorType = (selectedOption) => {
    setFormValues({
      ...formValues,
      distributorId: selectedOption?.value,
      assignedEngineerId:""
    });
    setFormErrors({
      ...formErrors,
      distributorId: !selectedOption
    });
  };

  {/* <!--Additional Contact in Customer--> */ }
  const handleContactSubmit = (event) => {
    // setContactError(validationContact(contacttemp));
    setContactError(validationContact(contacttemp, contact));
    setContactSubmit(true);
  };

  const EditContact = (editContactItem) => {
    setContactTemp(editContactItem)
    setContactShow(true);
  }

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactTemp({
      ...contacttemp,
      [name]: value,
    });

    const errors = validationContact({
      ...contacttemp,
      [name]: value
    });

    // update the formErrors state
    setContactError({
      ...contactError,
      [name]: errors[name]
    });

  };

  const deleteContact = (delContact) => {
    const list = [...contact];
    const temp_index = list.findIndex(x => x.id === delContact.id);
    list.splice(temp_index, 1);
    setContact(list);
  }

  const handleConDepChange = (selectedOption) => {
    setConDepartment(selectedOption)
    setContactTemp({
      ...contacttemp,
      departmentId: selectedOption.value,
    });

    setContactError({
      ...contactError,
      departmentId: !selectedOption.value,
    });

  };

  const handleConDesChange = (selectedOption) => {
    setConDesignation(selectedOption)
    setContactTemp({
      ...contacttemp,
      designationId: selectedOption.value,
      designation: selectedOption.label
    });

    setContactError({
      ...contactError,
      designationId: !selectedOption.value,
      designation: !selectedOption.label
    });
  };

  useEffect(() => {
    const contactlist = contact?.map((element, index) => {
      let contactdata = {
        name: element.name,
        phone: element.phone,
        email: element.email,
        designationId: element.designationId,
        departmentId: element.departmentId
      }
      return contactdata;
    });
    setFormValues(f => ({ ...f, customerContact: contactlist }));
  }, [contact]);

  useEffect(() => {
    if (Object.keys(contactError).length === 0 && contactSubmit) {

      if (contacttemp.id > 0) {

        setContact(c => {
          if (contacttemp.id > 0) {
            return c.map((element, index) => {
              if (element?.id === contacttemp?.id) {
                element.id = contacttemp.id;
                element.name = contacttemp.name;
                element.phone = contacttemp.phone;
                element.email = contacttemp.email;
                element.designationId = contacttemp.designationId;
                element.departmentId = contacttemp.departmentId;
                element.designation = contacttemp.designation;
              }
              return element;
            });
          } else {
            let contactUpdId = { ...contacttemp, id: (c?.length * 1) + 1 }
            return [...c, contactUpdId];
          }
        });


      } else {
        let contactUpdId = { ...contacttemp, id: (contact?.length * 1) + 1 }
        setContact([...contact, contactUpdId]);
      }

      setContactShow(false);
      setContactTemp({})
      setContactSubmit(false);
    }

  }, [contactError, contact, contactSubmit, contacttemp]);



  const clearFormValues = () => {
    setFormValues({});
    navigate("/customer-master");
  }

  const handleDocumentChange = (e, docId) => {
    const dd = formValues?.docs?.map((obj, ind) => {
      if (obj?.id == docId) {
        return {
          ...obj,
          fileObj: e.target.files[0],
          fileName: e.target.files[0].name,
          file: {
            ...obj?.file,
            documentId: docId,
            docuUrl: e.target.files[0].name,
            expDate: null
          },
        };
      }
      return obj;
    });
    var results = dd?.filter((item) => item?.fileName != "");
    var re = results?.map((it) => {
      return it?.file;
    });
    setFormValues({
      ...formValues,
      docs: dd,
      customerDocument: re,
    });
  };

  const removeAttachedFile = (docId, index) => {
    const dd = formValues?.docs?.map((obj, ind) => {
      if (obj?.id == docId) {
        return {
          ...obj,
          fileObj: "",
          fileName: "",
          file: {
            ...obj?.file,
            documentId: "",
            docuUrl: "",
            expDate: null
          },
        };
      }
      return obj;
    });
    const newValues = formValues?.customerDocument.filter(
      (obj) => obj?.documentId != docId
    );
    setFormValues({
      ...formValues,
      docs: dd,
      customerDocument: newValues,
    });
  };

  const handleAttachmentDate = (date, docId) => {
    // Find the document with the given ID and update its expiration date
    const updatedDocs = formValues?.docs?.map((doc) => {
      if (doc?.id === docId) {
        return {
          ...doc,
          file: {
            ...doc.file,
            expDate: date,
          },
        };
      }
      return doc;
    });

    // Find the customer document with the given ID and update its expiration date
    const updatedCustomerDocs = formValues.customerDocument.map((customerDoc) => {
      if (customerDoc.documentId === docId) {
        return {
          ...customerDoc,
          expDate: date,
        };
      }
      return customerDoc;
    });
    // Update the form values with the new arrays of updated documents and customer documents
    setFormValues({
      ...formValues,
      docs: updatedDocs,
      customerDocument: updatedCustomerDocs,
    });
  };

  //server Error shows 
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: ""
  });

  const ErrorDoneClick = () => {
    setErrorShow(
      {
        show: false,
        errorMessage: ""
      })
    setCreateMsg(null);
  }

  //Successfull show
  const SuccessDoneClick = () => {
    setShow(false);
    setDisabled(false);
    navigate("/customer-master")
  }

  useEffect(() => {
    if (CheckNull(createMsg?.message).includes('Failed')) {
      setErrorShow(
        {
          show: true,
          errorMessage: createMsg.successData
        })
      setDisabled(false);
    }
    else if (CheckNull(createMsg?.message) !== "") {
      setShow(true)
      setFormErrors({});
      setFormValues({})
    }
  }, [createMsg])

  //Document changes
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    const derr = [...docError];
    const err = { ...formErrors };

    if (formValues?.docs) {
      formValues.docs.forEach((obj, index) => {
        if (obj?.fileName !== '') {
          if (obj?.dateValidation) {
            if (obj?.file?.expDate === null) {
              derr[index] = ValidateMessages?.SELECTED("Expired Date");
            } else {
              derr[index] = false;
            }
          } else {
            derr[index] = false;
          }
        } else {
          derr[index] = false;
        }
      });
    }

    setFormErrors(err);
    setDocError(derr);
  }, [formValues?.docs]);


  const handleFormSubmit = (event) => {
    event.preventDefault();
    setFormErrors(validation(formValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    const errorCount = Object.values(validation(formValues)).filter(Boolean).length;
    if (errorCount === 0 && !docError.includes(ValidateMessages?.SELECTED("Expired Date")) && isSubmit) {
      setDisabled(true);
      let formData = { ...formValues };
      const dd = formData["docs"]?.filter((obj) => obj?.fileName != "");
      const format = dd?.map((obj) => {
        if (obj?.file?.expDate != null) {
          const dt = convertLocalToUTCDate(obj?.file?.expDate)
          return {
            ...obj,
            file: {
              ...obj?.file,
              expDate: dt
            }
          }
        }
        return obj
      });
      formData["customerDocument"] = format?.map((ob) => ob?.file);
      delete formData["docs"];
      if (CheckNull(formValues?.id) !== "") {
        UpdateEntry("Customer", formData, setCreateMsg, SuccessMessages?.UPDATED("Customer"), ErrorMessages?.UPDATE_ERROR("Customer"))
      } else {
        CreateEntry("Customer", formData, setCreateMsg, SuccessMessages?.CREATED("Customer"), ErrorMessages?.CREATE_ERROR("Customer"))
      }
    }
    setIsSubmit(false);
  }, [formErrors]);

  const AdditionalContactClose = () => {
    setContactShow(false);
    setContactSubmit(false);
    setContactTemp({})
    setConDepartment(null);
    setConDesignation(null);
    setContactError({})
    setContactShow(false);
  }



  return {
    customerStatusData,
    setCustomerStatusData,
    handleStatusChange,
    condepartment,
    condesignation,
    handleFormChange,
    formValues,
    setFormValues,
    country,
    setCountry,
    setDistributortype,
    setSalesEngineerData,
    handleCountryChange,
    handleSalesEngChange,
    handleCustomerType,
    distributortype,
    handleDistributorType,
    handleFormSubmit,
    formErrors,
    setConDesignation,
    handleImageFileChange,
    createMsg,
    show,
    setShow,
    setContactShow,
    contactShow,
    contact,
    contactError,
    contacttemp,
    setContactTemp,
    deleteContact,
    EditContact,
    handleContactSubmit,
    handleContactChange,
    setConDepartment,
    clearFormValues,
    handleConDepChange,
    handleConDesChange,
    salesEngineerData,
    errorShow,
    ErrorDoneClick,
    SuccessDoneClick,

    handleDocumentChange,
    removeAttachedFile,
    handleAttachmentDate,
    setFormErrors,
    selectedOptions,
    setSelectedOption,
    docError,
    setDocError,
    disabled,
    AdditionalContactClose,
    setContactError


  };
};

export default useForm;
